// lib/utils/nowTime.js
export function nowTime(locale = "ko-KR") {
  return new Date().toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
